export default {
  cn: [
    {
      version: '2.1.0',
      time: '2022.02.26',
      changes: [
        '增加 scoped slots 作用域插槽支持，可根据数据状态进行内容定制',
        '增加 <kbd class="kbd-code">displayAll</kbd> 属性用于显示所有数据记录',
        '使用 flex 模式进行样式重构',
        '<kbd class="kbd-code">border</kbd> 属性使用 <strong>false</strong> 作为默认值'
      ]
    }, {
      version: '2.0.10',
      time: '2021.11.14',
      changes: [
        '重构部分代码结构',
        '修复页码显示不完整问题',
        '增加 <kbd>.d.ts</kbd> 文件',
        '修改 sass 功能库 <kbd>node-sass</kbd> 为 <kbd>sass</kbd>',
        '添加部分单元测试项目',
        '在 <strong>CircleCI</strong> 构建脚本项目中移除 <kbd>node-sass</kbd>'
      ]
    }, {
      version: '2.0.9',
      time: '2020.06.19',
      changes: [
        '重构内部处理逻辑',
        '修改 css 预处理格式从 <kbd>SCSS</kbd> 为 <kbd>SASS</kbd>',
        '增加 <strong>德语</strong>，语言关键字为 <kbd class="kbd-code">de</kbd>'
      ]
    }, {
      version: '2.0.8',
      time: '2019.06.06',
      changes: [
        '将渲染方式从模板（template）修改为渲染函数（render）',
        '优化部分内部计算模块',
        '优化部分样式内容'
      ]
    }, {
      version: '2.0.7',
      time: '2019.05.03',
      changes: [
        '优化部分样式内容',
        '增加 <kbd class="kbd-code">v-model</kbd> 参数接收，设置当前页/默认页',
        '增加 <kbd class="kbd-code">border</kbd> 参数，设置分页栏边框',
        '增加 <kbd class="kbd-code">page-number</kbd> 参数，设置是否显示页码栏',
        '增加 <kbd class="kbd-code">first</kbd> 参数，设置是否显示首页按钮',
        '增加 <kbd class="kbd-code">last</kbd> 参数，设置是否显示尾页按钮',
        '增加 <kbd class="kbd-code">border、pageNumber、first、last</kbd> 参数可全局配置'
      ]
    }, {
      version: '2.0.0',
      time: '2018.10.25',
      changes: [
        '重构插件',
        '修改参数配置方式从参数集到单个属性独立设置',
        '优化部分样式内容',
        '增加 <kbd class="kbd-code">disabled</kbd> 参数，允许禁用整个分页栏',
        '增加部分参数可全局配置'
      ]
    }, {
      version: '1.4-1.6',
      time: '2018.04.26',
      changes: [
        '修复页码会消失的问题'
      ]
    }, {
      version: '1.3',
      time: '2018.04.22',
      changes: [
        '添加 <kbd class="kbd-code">align</kbd> 选项，用于设置分页栏的对齐方向'
      ]
    }, {
      version: '1.0-1.2',
      time: '2018.03-2018.04',
      changes: [
        '开发并发布基于 <kbd>Vue2.x</kbd> 的 <kbd>v-page</kbd> 插件'
      ]
    }
  ],

  en: [
    {
      version: '2.1.0',
      time: '2022.02.26',
      changes: [
        'Add scoped slots support',
        'Add <kbd class="kbd-code">displayAll</kbd> prop to show all records',
        'Use flex for styling refactoring',
        '<kbd class="kbd-code">border</kbd> prop use false by default'
      ]
    }, {
      version: '2.0.10',
      time: '2021.11.14',
      changes: [
        'Refactoring part of the code structure',
        'Fixed page number buttons incomplete in front and rear pages',
        'Add <kbd>.d.ts</kbd> file',
        'Change sass library from <kbd>node-sass</kbd> to <kbd>sass</kbd>',
        'Add some unit test items',
        'Remove <kbd>node-sass</kbd> build script from <strong>CircleCI</strong> pipeline'
      ]
    }, {
      version: '2.0.9',
      time: '2020.06.19',
      changes: [
        'Refactor internal processing structure',
        'Change css pre-processors format from <kbd>SCSS</kbd> to <kbd>SASS</kbd>',
        'Add <strong>German</strong> language, the language key is <kbd class="kbd-code">de</kbd>'
      ]
    }, {
      version: '2.0.8',
      time: '2019.06.06',
      changes: [
        'Change rendering method from template to render functions',
        'Optimize some internal calculation modules',
        'Optimize some style content'
      ]
    }, {
      version: '2.0.7',
      time: '2019.05.03',
      changes: [
        'Optimize some style content',
        'Add <kbd class="kbd-code">v-model</kbd> option support, set current page number/default page number',
        'Add <kbd class="kbd-code">border</kbd> option, set whether display pagination bar border',
        'Add <kbd class="kbd-code">page-number</kbd> option, set whether display page number buttons',
        'Add <kbd class="kbd-code">first</kbd> option，set whether to display the first page button',
        'Add <kbd class="kbd-code">last</kbd> option, set whether to display the last page button',
        'Add <kbd class="kbd-code">border, pageNumber, first, last</kbd> options can config in plugin install'
      ]
    }, {
      version: '2.0.0',
      time: '2018.10.25',
      changes: [
        'Rebuild plugin',
        'Change options set way from options sets to attribute set one by one',
        'Optimize some style content',
        'Add <kbd class="kbd-code">disabled</kbd> option, allow to enabled/disabled pagination bar',
        'Some options can config on global scope'
      ]
    }, {
      version: '1.4-1.6',
      time: '2018.04.26',
      changes: [
        'Fixed some time page number will disappear problem.'
      ]
    }, {
      version: '1.3',
      time: '2018.04.22',
      changes: [
        'Add <kbd class="kbd-code">align</kbd> option, set pagination bar alignment direction.'
      ]
    }, {
      version: '1.0-1.2',
      time: '2018.03-2018-04',
      changes: [
        'Develop and publish <kbd>v-page</kbd> plugin for <kbd>Vue2</kbd>'
      ]
    }
  ]
}
